// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__BbMl6","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3s3J0"};